import React from 'react'

import TaskTypeIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5"

type Props = {
    task            : any
    usersOptions    : any[]
}

export default function CopySubtaskItem(props: Props) {

    return (
        <div className="subtask-item">
            <div className="subtask-type-icon"><TaskTypeIcon taskTypeId={props.task.taskTypeId}/></div>
            <div className="subtask-title">{props.task.title}</div>
        </div>
    )
}